import { ApiError, convertObjectToJson } from '@gorila-shared-ui/components';
import { del, get, post } from 'aws-amplify/api';
import { downloadData, getUrl, uploadData } from 'aws-amplify/storage';
import { API_ENDPOINT_NAMES } from '../constants/api';
import { environment } from '../environments/environment';
import { ApiEndpoint } from '../types/api';
import { getErrorMessage } from '../utils/apiErrorResponse';

export const getRequest = async (
  path: string,
  params = {},
  dataType: 'json' | 'text' = 'json',
  endpoint: ApiEndpoint = ApiEndpoint.gnpKmSeguros,
): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await get({
      apiName: API_ENDPOINT_NAMES[endpoint],
      path,
      options: {
        ...convertObjectToJson(params),
      },
    }).response;
    if (dataType === 'text')
      return {
        data: await response.body.text(),
      };
    return {
      data: await response.body.json(),
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};

export const getOpenRequest = async (path: string, params = {}): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await get({
      apiName: environment.awsOpenAPIEndpointName,
      path,
      options: {
        ...convertObjectToJson(params),
        headers: {
          'x-api-key': `${environment.awsOpenAPIKey}`,
        },
      },
    }).response;
    return {
      data: await response.body.json(),
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};

export const postRequest = async (
  path: string,
  params = {},
  endpoint: ApiEndpoint = ApiEndpoint.gnpKmSeguros,
): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await post({
      apiName: API_ENDPOINT_NAMES[endpoint],
      path,
      options: {
        ...convertObjectToJson(params),
      },
    }).response;
    try {
      return {
        data: await response.body?.json(),
      };
    } catch {
      return {
        data: undefined,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};

export const fileRequest = async (path: string) => {
  try {
    return {
      data: {
        url: (await getUrl({ path })).url.href,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const uploadRequest = async (path: string, file: File, options = {}) => {
  try {
    return {
      data: {
        key: (await uploadData({ path, data: file, options }).result).path,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const downloadRequest = async (path: string) => {
  try {
    const responseBody = (await downloadData({ path }).result).body;
    return {
      data: {
        file: await responseBody.blob(),
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const deleteRequest = async (
  path: string,
  params = {},
  endpoint: ApiEndpoint = ApiEndpoint.gnpKmSeguros,
): Promise<{ data?: any; error?: ApiError }> => {
  try {
    return {
      data: await del({
        apiName: API_ENDPOINT_NAMES[endpoint],
        path,
        options: {
          ...convertObjectToJson(params),
        },
      }).response,
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};
